'use client';

import { Box, FormControl, Grid, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import type { Dayjs } from 'dayjs';
import React from 'react';

import { dayjs } from '../../../utils';
import { BuildingsMultiSelect } from './buildingsMultiSelect';

export const LeasingRightFormInputs = ({ formData, buildings, handleInputChangeLeasingRight, editMode }) => (
	<Box borderBottom='solid lightgray' paddingTop='2em' paddingBottom='2em'>
		<Grid container spacing={3}>
			<Grid item xs={3}>
				<FormControl style={{ width: '100%' }}>
					<TextField
						id='account-id-input-leasing-right'
						label='Account ID'
						name='accountId'
						value={formData.accountId ? `AC-${formData.accountId}` : ''}
						onChange={handleInputChangeLeasingRight}
						InputLabelProps={{ shrink: true }}
						disabled
						autoComplete='off'
						inputProps={{ 'data-cy': 'account-id-input' }}
					/>
				</FormControl>
			</Grid>
			<Grid item xs={3}>
				<FormControl style={{ width: '100%' }}>
					<TextField
						id='right-name-leasing-right'
						label='Right Name'
						name='rightName'
						required
						value={formData.rightName || ''}
						onChange={handleInputChangeLeasingRight}
						InputLabelProps={{ shrink: true }}
						autoComplete='off'
						disabled={!editMode}
						inputProps={{ 'data-cy': 'right-name-input' }}
					/>
				</FormControl>
			</Grid>
			<Grid item xs={3}>
				<BuildingsMultiSelect
					formData={formData}
					disabled={!editMode}
					buildings={buildings}
					handleInputChangeLeasingRight={handleInputChangeLeasingRight}
				/>
			</Grid>
			<Grid item xs={3} />
			<Grid item xs={3}>
				<FormControl style={{ width: '100%' }}>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DatePicker<Dayjs>
							label='Commencement Date'
							format='MM/DD/YYYY'
							value={dayjs.utc(formData.commencementDate)}
							onChange={(value) =>
								handleInputChangeLeasingRight({ target: { name: 'commencementDate', value } })
							}
							disabled={!editMode}
							slotProps={{
								textField: {
									required: true,
								},
								openPickerIcon: { 'data-cy': `commencement-date-picker` },
							}}
						/>
					</LocalizationProvider>
				</FormControl>
			</Grid>
			<Grid item xs={3}>
				<FormControl style={{ width: '100%' }}>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DatePicker<Dayjs>
							label='Expiration Date'
							format='MM/DD/YYYY'
							value={dayjs.utc(formData.expirationDate)}
							onChange={(value) =>
								handleInputChangeLeasingRight({ target: { name: 'expirationDate', value } })
							}
							disabled={!editMode}
							slotProps={{
								textField: {
									required: true,
								},
								openPickerIcon: { 'data-cy': `expiration-date-picker` },
							}}
						/>
					</LocalizationProvider>
				</FormControl>
			</Grid>
			<Grid item xs={3}>
				<FormControl style={{ width: '100%' }}>
					<TextField
						id='suites-leasing-right'
						label='Suites'
						name='suites'
						value={formData.suites || ''}
						onChange={handleInputChangeLeasingRight}
						InputLabelProps={{ shrink: true }}
						disabled={!editMode}
						inputProps={{ 'data-cy': 'suites-input' }}
					/>
				</FormControl>
			</Grid>
			<Grid item xs={3}>
				<FormControl style={{ width: '100%' }}>
					<TextField
						id='square-feet-leasing-right'
						label='Square Feet'
						name='squareFeet'
						type='text'
						value={formData.squareFeet || ''}
						onChange={handleInputChangeLeasingRight}
						InputLabelProps={{ shrink: true }}
						autoComplete='off'
						disabled={!editMode}
						inputProps={{ 'data-cy': 'square-feet-input' }}
					/>
				</FormControl>
			</Grid>
			<Grid item xs={6}>
				<FormControl style={{ width: '100%' }}>
					<TextField
						multiline
						rows={3}
						id='extension-options-leasing-right'
						label='Extension Options'
						name='extensionOptions'
						value={formData.extensionOptions || ''}
						onChange={handleInputChangeLeasingRight}
						InputLabelProps={{ shrink: true }}
						disabled={!editMode}
						inputProps={{ 'data-cy': 'extension-options-input' }}
					/>
				</FormControl>
			</Grid>
			<Grid item xs={12}>
				{formData.createdBy && (
					<Grid container spacing={2} style={{ marginBottom: '15px' }}>
						<Grid item xs={7}>
							<TextField
								fullWidth
								label='Created By'
								name='createdBy'
								value={formData.createdBy || ''}
								disabled
								variant='standard'
								InputLabelProps={{ shrink: true }}
							/>
						</Grid>
						<Grid item xs={5}>
							<TextField
								fullWidth
								label='Created At'
								name='createdAt'
								value={formData.createdAt || ''}
								disabled
								variant='standard'
								InputLabelProps={{ shrink: true }}
							/>
						</Grid>
					</Grid>
				)}
				{formData.updatedBy && (
					<Grid container spacing={2}>
						<Grid item xs={7}>
							<TextField
								fullWidth
								label='Updated By'
								name='updatedBy'
								value={formData.updatedBy || ''}
								disabled
								variant='standard'
								InputLabelProps={{ shrink: true }}
							/>
						</Grid>
						<Grid item xs={5}>
							<TextField
								fullWidth
								label='Updated At'
								name='updatedAt'
								value={formData.updatedAt || ''}
								disabled
								variant='standard'
								InputLabelProps={{ shrink: true }}
							/>
						</Grid>
					</Grid>
				)}
			</Grid>
		</Grid>
	</Box>
);
